import {
  getCoupon,
  saveCoupon,
  getCouponAll
} from '@/api/coupon'
export default {
  state: {

  },
  actions: {
    getCoupon ({
      commit
    }, payload) {
      return new Promise(resolve => {
        getCoupon(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    saveCoupon ({
      commit
    }, payload) {
      return new Promise(resolve => {
        saveCoupon(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    getCouponAll ({
      commit
    }, payload) {
      return new Promise(resolve => {
        getCouponAll(payload).then(res => {
          resolve(res.data)
        })
      })
    }
  },
  getters: {

  },
  mutations: {

  }
}
